import TechnologiesList from './TechnologiesList'
import DefinesUsSection from './DefinesUsSection'
import WordsOfAppreciation from './WordsOfAppreciation'
import ContactUsForm from './ContactUsForm'
import BusinessGrow from './BusinessGrow'
import GameChangingIdea from './GameChangingIdea'
import TemplateSlider from './TemplateSlider'
import FAQs from './FAQ'
import WhyChooseOur from './WhyChooseOur'
import TechNServicesHeroSection from './TechNServicesHeroSection'
import AiMlAutomation from './GreenSliderAutomation/AiMlAutomation'

export {
   AiMlAutomation,
   TechnologiesList,
   TechNServicesHeroSection,
   DefinesUsSection,
   WordsOfAppreciation,
   ContactUsForm,
   BusinessGrow,
   GameChangingIdea,
   TemplateSlider,
   FAQs,
   WhyChooseOur,
}
